import { useFormConfigContext } from "../../../common/contexts/FormConfigContext";
import { useFormContext } from "../../../common/contexts/FormContext";
import { validateOffer } from "../../../service/apiService";
import { useCallback } from "react";

export const useCheckAndValidateCouponFromUrl = () => {
  const { formConfig } = useFormConfigContext();
  const { setFormValues } = useFormContext();
  const checkAndValidateCoupon = useCallback(async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const couponCode = urlParams.get("offer_code");
      const conceptid = formConfig?.conceptid;
      const weblocationId =
        localStorage.getItem("franchiseWebLocationId") || "0";
      if (!couponCode) {
        return;
      }
      while (typeof window?.GetCachedUnifiedSync === "undefined") {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      const validationResult = await validateOffer(
        conceptid,
        couponCode,
        weblocationId,
        undefined,
        false
      );

      if (validationResult.success) {
        setFormValues((prevValues) => ({
          ...prevValues,
          offerValidationFailed: false,
        }));
      } else {
        setFormValues((prevValues) => ({
          ...prevValues,
          offerValidationFailed: true,
        }));
      }
    } catch (error) {
      console.error("Error validating coupon from URL:", error);
    }
  }, [formConfig.conceptid]);

  return checkAndValidateCoupon;
};
